import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'trend-lines-chart',
    templateUrl: 'trend-line.component.html',
    styleUrls: ['trend-line.component.css', '../../charts.style.scss']
})

export class TrendLinesChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;
    chart: any;

    constructor() {
    }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data.data = this.chartSpecification.data.data || [];
        this.chartSpecification.data.trendLines = this.chartSpecification.data.trendLines || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "multiDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.valueAxes = this.chartSpecification.valueAxes || [];
        this.chartSpecification.precision = this.chartSpecification.precision || 0

        if (typeof this.chartSpecification.parseDates === "undefined") {
            this.chartSpecification.parseDates = true;
        }
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            this.chart = AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "marginRight": 80,
                "autoMarginOffset": 20,
                //"dataDateFormat": "YYYY-MM-DD HH:NN",
                //"mouseWheelZoomEnabled": true,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "dataProvider": this.chartSpecification.data.data,
                "valueAxes": [{
                    "axisAlpha": 0,
                    "guides": [{
                        "fillAlpha": 0.1,
                        "fillColor": "#888888",
                        "lineAlpha": 0,
                        "toValue": 16,
                        "value": 10,
                    }],
                    "title": this.chartSpecification.yAxisTitle,
                    "bold": true,
                    "position": "left",
                    "tickLength": 0
                }],
                "graphs": [{
                    "balloonText": "[[category]]<br><b><span style='font-size:14px;'>value:[[value]]</span></b>",
                    "bullet": "round",
                    "dashLength": 3,
                    "colorField": "color",
                    "valueField": this.chartSpecification.yAxis,
                    "precision": this.chartSpecification.precision
                }],
                "trendLines": this.chartSpecification.data.trendLines,
                "chartScrollbar": {
                    "scrollbarHeight": 2,
                    "offset": -1,
                    "backgroundAlpha": 0.1,
                    "backgroundColor": "#888888",
                    "selectedBackgroundColor": "#67b7dc",
                    "selectedBackgroundAlpha": 1
                },
                "chartCursor": {
                    "fullWidth": true,
                    "valueLineEabled": true,
                    "valueLineBalloonEnabled": true,
                    "valueLineAlpha": 0.5,
                    "cursorAlpha": 0
                },
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "parseDates": this.chartSpecification.parseDates,
                    "axisAlpha": 0,
                    "gridAlpha": 0.1,
                    "minorGridAlpha": 0.1,
                    "minorGridEnabled": true
                },
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });

            this.chart.addListener("dataUpdated", this.zoomChart);

        }, 20);
    }

    zoomChart() {
        this.chart.zoomToDates(new Date(2012, 0, 2), new Date(2012, 0, 13));
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/lineCharts/trend-line/trend-line.component.ts